// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1AJLC","vLegacy":"SelectSecondary_vLegacy__1ic5j","error":"SelectSecondary_error__2aIaF","disabled":"SelectSecondary_disabled__2cAc1"};